import { createContext, useContext, useEffect, useState } from "react";
import { ws } from "./utils/common";
import { setGlobalState } from "./utils/state";
import { registerPushNotifications } from "./utils/pushManager";

const ReloadContext = createContext();

/**
 * Provider globale per la gestione del soft reload dell'app.
 * Ogni volta che `softReload` viene chiamata, il valore di `reloadTrigger` cambia,
 * attivando l'effetto `useEffect` associato in questo modo farò una chiamata all'api getUserInfo()
 * che mi restituirà i dettagli personali dell'utente come nome, cognome, email, fotoprofilo, se è admin ecc ecc.
 *
 * @param {Object} props - Proprietà del componente
 * @param {React.ReactNode} props.children - I componenti figli che saranno avvolti dal provider
 * @returns {JSX.Element} Il provider che avvolge i componenti dell'app
 */
export const ReloadProvider = ({ children }) => {
  const [reloadTrigger, setReloadTrigger] = useState(false);

  const softReload = () => setReloadTrigger((prev) => !prev);

  useEffect(() => {
    if (localStorage.getItem("accessToken")) {
      ws("GET", process.env.REACT_APP_ENDPOINT + "user", null, null, true)
        .then((res) => {
          setGlobalState("admin", res.data.admin);
          setGlobalState("numberNotifications", res.data.number_notifications);

          localStorage.setItem("name", res.data.name);
          localStorage.setItem("surname", res.data.surname);
          localStorage.setItem("admin", res.data.admin);
          localStorage.setItem(
            "imageProfile",
            res.data.image_profile
              ? "data:" +
                  res.data.image_type +
                  ";base64," +
                  res.data.image_profile
              : "/no_img.png"
          );
        })
        .catch((err) => console.log(err));

      registerPushNotifications().catch(console.error);
    }
  }, [reloadTrigger]);

  return (
    <ReloadContext.Provider value={{ softReload }}>
      {children}
    </ReloadContext.Provider>
  );
};

export const useReload = () => useContext(ReloadContext);
